import * as intlTelInput from 'intl-tel-input'
import utilsScript from 'intl-tel-input/build/js/utils.js'

// let countryData = window.intlTelInputGlobals.getCountryData()

export const input = document.querySelector('input[type=tel]')

/**
 * @link https://github.com/jackocnr/intl-tel-input
 *
 * iti.setCountry('bj')
 * iti.setNumber('97593100')
 * iti.getSelectedCountryData()
 * {
 *     name: "Afghanistan (‫افغانستان‬‎)",
 *     iso2: "af",
 *     dialCode: "93"
 *  }
 * iti.getNumber()
 * iti.getNumber(intlTelInputUtils.numberFormat.E164)
 */
export let iti

if (input) {
    iti = intlTelInput(input, {
        utilsScript,
        separateDialCode: true,
        formatOnDisplay: false,
        preferredCountries: ['de', 'ch', 'at', 'fr', 'nl', 'be', 'us'],
        initialCountry: 'auto',
        geoIpLookup(success, failure) {
            fetch(`https://api.ipdata.co/?api-key=${process.env.MIX_IPDATA_KEY}`)
                .then((response) => {
                    if (!response.ok) return success('de')
                    return response.json()
                })
                .then((ipdata) => {
                    success(ipdata.country_code)
                })
                .catch(error => {
                    success('de')
                })
        },
    })
}

// Breeder Registration Phone Input
const breederRegistrationPhoneInput = document.querySelector('#breeder-registration #phone')
if (breederRegistrationPhoneInput) {
    intlTelInput(breederRegistrationPhoneInput, {
        utilsScript,
        customPlaceholder: '',
        separateDialCode: true,
        formatOnDisplay: false,
        preferredCountries: ['de', 'dk', 'nl', 'be', 'fr', 'se', 'gb'],
        onlyCountries: ['de', 'dk', 'nl', 'be', 'fr', 'se', 'gb'],
    })
}

// Foal / Mare Registration Phone Inputs
const phoneInputs = document.querySelectorAll('#registration-fm-wrap .phone')
phoneInputs.forEach(function (input) {
    intlTelInput(input, {
        utilsScript,
        customPlaceholder: () => '',
        separateDialCode: true,
        formatOnDisplay: false,
        preferredCountries: ['de', 'ch', 'at', 'fr', 'nl', 'be', 'us'],
        initialCountry: 'auto',
        geoIpLookup(success, failure) {
            fetch(`https://api.ipdata.co/?api-key=${process.env.MIX_IPDATA_KEY}`)
                .then((response) => {
                    if (!response.ok) return success('de')
                    return response.json()
                })
                .then((ipdata) => {
                    success(ipdata.country_code)
                })
                .catch(error => {
                    success('de')
                })
        },
    })
})
